import React,  {useState} from 'react';
import PropTypes from 'prop-types';
import { useSpring, animated, easings } from '@react-spring/web';
import { ReactSVG } from 'react-svg';
import sunRays from '../../assets/backgrounds/high_sun_rays.svg';
import '../Slides.scss'
import './TotalSkillsSlide.scss';

const TotalSkillsSlide = ({ data }) => {

  const {
    skills_completed,
    title,
    subTitle,
    kid_name
  } = data;

  const [fadeInDone, setFadeInDone] = useState(false);

   const titleSpring = useSpring({
     from: { opacity: 0, transform: 'translateY(20px)' },
     to: { opacity: 1, transform: 'translateY(0px)' },
     config: { tension: 200, friction: 25 },
     delay: 400,
   });
 
   const subTitleSpring = useSpring({
     from: { opacity: 0, transform: 'translateY(20px)' },
     to: { opacity: 1, transform: 'translateY(0px)' },
     config: { tension: 200, friction: 25 },
     delay: 600,
   });
 
   const concertCountSpring = useSpring({
     from: { opacity: 0, transform: 'scale(2)' },
     to: { opacity: 1, transform: 'scale(1)' },
     config: { tension: 280, friction: 20 },
     delay: 1200,
   });
 
   const concertCountWrapperSpring = useSpring({
     from: { opacity: 0 },
     to: { opacity: 1 },
     delay: 1000,
   })
 
   const textSpring = useSpring({
     from: { opacity: 0, transform: 'translateY(20px)' },
     to: { opacity: 1, transform: 'translateY(0px)' },
     config: { tension: 200, friction: 25 },
     delay: 1000,
   });


     const sunRaysFadeInSpring = useSpring({
       from: { opacity: 0 },
       to: { opacity: 1 },
       config: { duration: 1000 },
       delay: 1000,
       onRest: () => setFadeInDone(true),
     });
   
     const sunRaysScaleSpring = useSpring({
       from: { scale: 1, rotate: '180deg' },
       to: { scale: 1.1 },
       loop: fadeInDone ? { reverse: true } : false,
       config: { duration: 1500, easing: easings.easeInOutSine },
     });
   
     const sunRaysSpring = {
       ...sunRaysFadeInSpring,
       ...sunRaysScaleSpring,
     };

  return (
    <div className='Slide__total_skills'>
      <animated.h2 className='Slide__total_skills__title' style={titleSpring}>Skills</animated.h2>
      <animated.h3
        className='Slide__total_skills__subTitle'
        style={{
          ...subTitleSpring,
          width: skills_completed > 5 ? '220px' : '182px'
        }}
      >
        {title}
        {skills_completed <= 5 && (
          <span className='Slide__total_skills__subTitle__kidName'>{kid_name}</span>
        )}
      </animated.h3>
      <animated.div className='Slide__total_skills__count' style={concertCountWrapperSpring}>
        <div className='Slide__total_skills__count__box'>
          <div className='Slide__total_skills__count__band' />
          {skills_completed > 5 ? (
            <animated.p style={concertCountSpring} className='Slide__total_skills__count__number'>{skills_completed}</animated.p>
          ) : (
            <animated.p style={concertCountSpring} className='Slide__total_skills__count__fallback'>300</animated.p>
          )}
          <animated.div
            className='Slide__total_skills__count__bottomLine'
            style={textSpring}
          >
            {subTitle}
            !!
          </animated.div>
        </div>
      </animated.div>
      <animated.div className='Slide__total_skills__sunRays' style={sunRaysSpring}>
        <ReactSVG src={sunRays} />
      </animated.div>
    </div>
  )
}

export default TotalSkillsSlide;

const DataProps = {
  skills_completed: PropTypes.number,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired
}

TotalSkillsSlide.propTypes = {
  data: PropTypes.shape(DataProps).isRequired
}
